function updateProductPricesToBeinSqft(timeout = 500){
	setTimeout(function(){
      $('.product-thumb, .product-template__container').each(function(item){
          var allLis = $(this).find('.noDisplayDesc ul li:contains("SF / Package"), #product-description ul li:contains("SF / Package")').text();
          var sqft = parseFloat(allLis);
          var price = $(this).find('li[class$="-caption-price-current"]');
          var priceNumber = Number(parseFloat(price.text().replace('$', '')).toFixed(2));
          price.text('$' + (priceNumber / sqft).toFixed(2) + '/sqft');
      });
	}, timeout);
}
jQuery(function($) {
  	updateProductPricesToBeinSqft(500);
});


$(document).on('click','.request-quote-form-active',function(event){
  event.preventDefault()
   $(document).find('.request-quote-form-active-campiagn').addClass('active');
    // $(document).find('.request-quote-submit').trigger('click');
})
$(document).on('click','.request-quote-form-close',function(event){
  event.preventDefault()
      $(document).find('.request-quote-form-active-campiagn').removeClass('active');
})